import { Link } from "react-router-dom";
import { products } from "../data/products";
import { categories } from "../data/categories";
import ProductGrid from "../components/ProductGrid";
import SEOMeta from "components/SEOMeta";
import { brandConfig } from "config/brandConfig";
import { useBreadcrumb } from "components/breadcrumb/BreadcrumbContext";
import { useEffect } from "react";
import CategorySEO from "components/CategorySEO";

export default function Products() {
  const { setItems } = useBreadcrumb();
  useEffect(() => {
    setItems([{ label: "Accueil", href: "/" }, { label: "Produits" }]);
  }, [setItems]);
  return (
    <>
      <SEOMeta
        title="Produits"
        description={`Découvrez toute la gamme ${brandConfig.brandName} : armoires à fusils, coffres-forts et armoires à clés sécurisées, conçues pour protéger vos armes, vos valeurs et vos clés.`}
        canonicalPath="/produits"
      />
      <CategorySEO
        products={products}
        canonicalPath="/produits"
        categoryName="Tous nos produits"
        description={`Catalogue complet des armoires à fusils, coffres-forts et armoires à clés sécurisées ${brandConfig.brandName}.`}
      />
      <h1>Produits</h1>
      <div className="buttons" style={{ marginBottom: 20 }}>
        {categories.map((category) => (
          <Link
            key={category.slug}
            to={category.canonicalPath}
            className="btn btn-ghost"
          >
            {category.categoryName}
          </Link>
        ))}
      </div>
      <ProductGrid products={products} />
    </>
  );
}
